import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';

class TableHead extends PureComponent {
  render() {
    const { tableHead, onSort } = this.props;
    return (
      <th onClick={() => onSort(tableHead.prop)} className={tableHead.class}>
        {tableHead.name}
      </th>
    );
  }
}

// props validation
TableHead.propTypes = {
  tableHead: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    class: PropTypes.string,
  }),
};
TableHead.defaultProps = {
  tableHead: {
    id: '1',
    name: 'ID',
    class: 'w-12',
    prop: ''
  },
};

export default TableHead;